<script setup lang="ts">
import { Ref, ref, onMounted } from 'vue';
import { useRoute } from 'vue-router'
import UserRoleForm from "@/components/UserRoleForm/UserRoleForm.vue";
import AuthorityCacheApi from "@/services/models/AuthorityCacheApi"
import i18n from '@/lang/i18n';

const title:Ref<string> = ref('');
const route = useRoute()

const userRoleId: Ref<number | null> = ref(null)
const updateAuthority: Ref<boolean> = ref(false)

const props = defineProps<{
  showFlash: (message: string, type: string, fadeout: boolean) => { value: any },
  switchContentLoading: (isLoading: boolean) => {value: any}
}>();

onMounted(() => {
  if (route.params.id) getAuthorities()
  setTitle()
})

async function getAuthorities() {
  const authorityList = await AuthorityCacheApi.getWithParse()
  updateAuthority.value = !!authorityList["octlink.user_role.update"]
}

function setTitle() {
  userRoleId.value = Number(route.params.id)
  const titlePrefix = i18n.global.t('pages.userRoles.title.formTitle')
  const titleSuffix = userRoleId.value ?
    i18n.global.t('pages.userRoles.title.editTitle') :
    i18n.global.t('pages.userRoles.title.createTitle')
  title.value = `${titlePrefix}/${titleSuffix}`
  document.title = title.value
}

function setUserRoleId(id: number) {
  userRoleId.value = id
}

function setContentLoading(status:boolean){
  props.switchContentLoading(status)
}

</script>
<template>
  <div style="min-height: 45vw;">
    <h4 class="content pl-3 w-100">{{ title }}</h4>
    <div class="row mr-3 ml-3 v-theme--light">
      <div class="mb-4">
        <UserRoleForm
          :userRoleId="userRoleId"
          :showFlash="props.showFlash"
          :updateAuthority="updateAuthority"
          @setUserRoleId="setUserRoleId"
          @setContentLoading="setContentLoading"
        />
      </div>
    </div>
  </div>
</template>

<style scooped>
.contentLoading>div>label{
  left: 50%!important;
}
</style>